/* eslint-disable import/prefer-default-export */
import { useDispatch } from "react-redux";
import ThemeActions from "redux-react/actions/themeActions";

export const useThemeActions = () => {
	const dispatch = useDispatch();

	/**
	 * Start training all questions from a category
	 * @param {*} code
	 * @param {*} type
	 * @param {*} messageID
	 * @param {*} onSuccess
	 * @param {*} onFailure
	 */
	const startCategoryTraining = (
		codes,
		type,
		messageID,
		onSuccess = () => {},
		onFailure = () => {}
	) => {
		dispatch(
			ThemeActions.startCategoryTraining(
				{
					codes,
					type,
					messageID
				},
				onSuccess,
				onFailure
			)
		);
	};

	/**
	 * Start untraining all questions from a category
	 * @param {*} code
	 * @param {*} type
	 * @param {*} onSuccess
	 * @param {*} onFailure
	 */
	const startCategoryUntraining = (codes, type, onSuccess = () => {}, onFailure = () => {}) => {
		dispatch(ThemeActions.startCategoryUntraining(codes, type, onSuccess, onFailure));
	};

	return {
		// 1 category
		startCategoryTraining,
		startCategoryUntraining
	};
};
